import { Button } from '@mui/material';
import { memo } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const DisplayFieldCard = ({ field, checked, onToggle }) => (
  <Button
    size="small"
    variant="contained"
    onClick={() => onToggle(field.id)}
    endIcon={<CheckCircleIcon sx={{ color: checked ? '#00ba00' : '#d7d7d7', fontSize: '16px' }} />}
    disableRipple
    disableElevation
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: 500,
      fontSize: '0.7rem',
      border: checked ? '0.1px solid #f6ffe6' : '0.1px solid #d7d7d7',
      backgroundColor: checked ? '#f6ffe6' : '#ffffff',
      color: 'black',
      borderRadius: '3px',
      textTransform: 'none',
      width: '250px',
      py: '2px',
      px: '10px',
      whiteSpace: 'nowrap',
      boxShadow: 'none',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: checked ? '#f6ffe6' : '#f8f8f8',
        boxShadow: 'none',
      },
    }}
  >
    {field.label}
  </Button>
);

export default memo(DisplayFieldCard);
